import { render, staticRenderFns } from "./physicalStorage.vue?vue&type=template&id=648d2128&"
import script from "./physicalStorage.vue?vue&type=script&lang=js&"
export * from "./physicalStorage.vue?vue&type=script&lang=js&"
import style0 from "./physicalStorage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports